import { render, staticRenderFns } from "./deny.vue?vue&type=template&id=38d5cc04"
import script from "./deny.vue?vue&type=script&lang=ts"
export * from "./deny.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports